import {cloneDeep} from 'lodash';
import {watch} from 'vue';
import { store } from '../../../../../resources/frontend/js/store';

export default (questions) => {
    // Create initial question flow
    store.commit('quiz/setQuiz', {
        key: 'allFlows',
        value: createAllFlows(questions[0], [], questions, []),
    });

    store.commit('quiz/setQuiz', { key: 'currentFlows', value: store.state.quiz.allFlows });
    store.commit('quiz/setQuiz', { key: 'equalFlow', value: isEqualFlow() });
    store.commit('quiz/setQuiz', { key: 'totalFlowLength', value: totalFlowLength()});

    // Update question flow whenever a question is answered
    watch(() => store.state.quiz.currentQuestion, () => {
        updateFlow();
    });
};

const createAllFlows = (question, currentFlow = [], questions, flows) => {
    const flow = cloneDeep(currentFlow);

    flow.push(questions.indexOf(question) + 1);

    question.answers.forEach(answer => {
        if(!answer.question) {
            flows.push(flow);
            return;
        }

        const nextQuestion = questions.find(question => question.uuid === answer.question);

        createAllFlows(nextQuestion, flow, questions, flows);
    });

    return flows;
};

const updateFlow = () => {
    const questionFlow = store.state.quiz.questionFlow;
    const allFlows = store.state.quiz.allFlows;

    const matchingFlows = allFlows.filter(flow => {
        for (let i = 0; i < questionFlow.length; i++) {
            if (flow[i] !== questionFlow[i]) return false;
        }

        return true;
    });

    store.commit('quiz/setQuiz', { key: 'currentFlows', value: matchingFlows });
    store.commit('quiz/setQuiz', { key: 'totalFlowLength', value: totalFlowLength()});
};

const totalFlowLength = () => {
    return Math.max(...store.state.quiz.currentFlows.map(flow => flow.length));
};

const isEqualFlow = () => {
    return [...new Set(store.state.quiz.allFlows.map(flow => flow.length))].length === 1;
};
